import Angular from "angular";
import Controller from "./chart-workload-colors-map.controller";
import Template from "./chart-workload-colors-map.html";

export default Angular.module('chart-workload-colors-map', [])
    .component('chartWorkloadColorsMap', {
        template: Template,
        controller: Controller,
        bindings: {
            workloads: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-workload-colors-map/chart-workload-colors-map.js